// extracted by mini-css-extract-plugin
module.exports = {"dp-empty":"dp-empty___1o1lK","dp-empty-pic":"dp-empty-pic___32nia"};